import styled from "styled-components";
import Button from "../Button";

const ICTHButton = styled(Button)`
  &.sunday-component-btn-primary,
  &.sunday-component-btn-default,
  &.sunday-component-btn-text {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }
  }

  &.sunday-component-btn-primary:not(:disabled) {
    border-color: var(--color-surface-ci-pri, #435dff);
    background-color: var(--color-surface-ci-pri, #435dff);

    &,
    &:hover,
    &:focus,
    &:active {
      border-color: var(--color-surface-ci-pri, #435dff);
      background-color: var(--color-surface-ci-pri, #435dff);

      * {
        color: var(--color-text-on-primary, #ffffff);
      }
    }
  }

  &.sunday-component-btn-default:not(:disabled) {
    border-color: var(--color-stroke-default, #d9dbde);

    &,
    &:hover,
    &:focus,
    &:active {
      * {
        color: var(--color-text-ci-pri, #435dff);
      }
    }
  }

  &.sunday-component-btn-text:not(:disabled) {
    &,
    &:hover,
    &:focus,
    &:active {
      * {
        color: var(--color-text-ci-pri, #435dff);
      }
    }
  }
`;

export default ICTHButton;
